<template>
	<div class="group-settings-dm-profile">
		<div class="profile-pics-container">
			<Tippy
				v-for="partner in partners"
				:key="partner?.id"
				:content="partner?.fullname"
				arrow
			>
				<ProfilePic
					:user="partner"
					:size="singlePartner ? '70px' : '40px'"
					class="profile-pic"
					@click="showProfile(partner)"
				/>
			</Tippy>
		</div>
		<div class="dm-username" :class="{ 'single-partner': singlePartner }">
			{{ partnerNames }}
		</div>
	</div>

	<ProfileCard
		v-if="showProfileCard"
		@close="showProfileCard = false"
		:profileData="selectedPartner"
	/>
</template>

<script>
import {
	getMembershipsForBubble,
	getMyUserId,
	getUser,
	sortUsersByFullname,
} from '@/store'
import { ProfilePic, Tippy } from '@/components/common'
import ProfileCard from '@/components/ProfileCard'

export default {
	name: 'DMOptions',
	components: { ProfilePic, Tippy, ProfileCard },
	props: { chatId: [Number, String] },
	data() {
		return {
			showProfileCard: false,
			selectedPartner: null,
		}
	},
	computed: {
		partners() {
			return getMembershipsForBubble(this.chatId)
				.filter((m) => m.user_id !== getMyUserId())
				.map((m) => getUser(m.user_id))
				.sort(sortUsersByFullname)
		},
		partnerNames() {
			return this.partners.map((p) => p?.fullname ?? 'unknown user').join(', ')
		},
		singlePartner() {
			return this.partners.length === 1
		},
	},
	methods: {
		getPartner(id) {
			return getUser(id)
		},
		showProfile(partner) {
			this.selectedPartner = partner
			this.showProfileCard = true
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.profile-pics-container {
	@include flex;
}

.profile-pic {
	border: 2px solid var(--neutral-100);
	border-radius: 50%;
	cursor: pointer;
}

:deep(.tippy-wrapper) {
	&:not(:first-child) {
		margin-left: -11.5px;
	}
}

.group-settings-dm-profile {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
}

.dm-username {
	font-size: 15px;
	font-family: Avenir-Roman;
	color: var(--neutral-800);
	margin-top: 15px;
	text-align: center;
}

.single-partner {
	font-size: 20px;
	margin-left: 0;
}
</style>
